export default __webpack_public_path__ + "static/media/factory__36.dc288480.jpg";